import { Injector } from '@angular/core';
import { HttpClient } from '@angular/common/http';

import { LOCATION_INITIALIZED } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { environment } from 'src/environments/environment';

export function HttpLoaderFactory(httpClient: HttpClient) {
    return new TranslateHttpLoader(httpClient);
}

export function ApplicationInitializerFactory(
    translate: TranslateService, injector: Injector) {
    return async () => {
        await injector.get(LOCATION_INITIALIZED, Promise.resolve(null));

        const configuredLanguageDefault: string = String((environment as any)?.languageDefault).toLowerCase();
        const defaultLanguage: string = ['pt-br', 'en', 'es'].includes(configuredLanguageDefault)
            ? configuredLanguageDefault
            : 'pt-br';

        translate.addLangs(['en', 'es', 'fr', 'pt-br', 'eninternal', 'pt-brinternal']);
        translate.setDefaultLang(defaultLanguage);

        try {
            await translate.use(defaultLanguage).toPromise();
        } catch (err) {
            console.log(err);
        }
    };
}
